<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="w-full xl:h-full flex flex-col xl:gap-6 gap-4 xl:p-6 p-4 pb-24">
    <NuxtLink
      to="/pricing"
      class="md:hidden fixed z-[9] left-0 w-full bottom-0 bg-white"
    >
      <Divider class="m-0" />
      <div class="p-4">
        <Button
          outlined
          severity="secondary"
          class="rounded-full py-2.5 text-white bg-neutral-90 border-neutral-90 border-2 w-full flex justify-center"
        >
          <span class="xl:text-22 text-18 font-bold">
            {{t('course.upsell.card.cta')}}
          </span>
        </Button>
      </div>
    </NuxtLink>

    <Card
      :class="[
        'upsell-card md:min-h-[435px] min-h-[335px] xl:h-full',
        'shadow-none !bg-yellow-50 rounded-2xl relative overflow-hidden'
      ]"
      :pt="{
        body: {
          class: 'h-full flex flex-col xl:p-8 xl:p-4 p-2'
        },
        content: {
          class: 'h-full flex flex-col p-0'
        }
      }"
    >
      <template #content>
        <div class="flex flex-col xl:justify-center xl:pl-6 gap-4 xl:w-[60%] w-full h-full">
          <div class="flex flex-col justify-center xl:max-w-[500px] gap-4 z-[1]">
            <div class="md:text-36 text-32 font-bold text-neutral-90 pt-4 px-4">
              {{t('course.upsell.card.title')}}
            </div>

            <div class="w-full md:text-20 text-18 px-4">
              {{t('course.upsell.card.description')}}
            </div>

            <div class="md:flex hidden w-full mt-4 px-4">
              <NuxtLink to="/pricing">
                <Button
                  outlined
                  severity="secondary"
                  class="rounded-full py-2.5 text-white bg-neutral-90 border-neutral-90 border-2"
                >
                  <span class="xl:text-22 text-18 font-bold">
                    {{t('course.upsell.card.cta')}}
                  </span>
                </Button>
              </NuxtLink>
            </div>
          </div>
        </div>
      </template>
    </Card>

    <div class="grid md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4">
      <UpsellCardAchievement
        :title="t('course.upsell.card.achievements.accreditedTitle')"
        class="min-w-[300px]"
      >
        {{t('course.upsell.card.achievements.accreditedDesc')}}
      </UpsellCardAchievement>

      <UpsellCardAchievement
        :title="t('course.upsell.card.achievements.partnerTitle')"
        class="min-w-[300px]"
      >
        {{t('course.upsell.card.achievements.partnerDesc')}}
      </UpsellCardAchievement>

      <UpsellCardAchievement
        :title="t('course.upsell.card.achievements.ratingTitle')"
        class="min-w-[300px]"
      >
        <span v-sanitize-html="t('course.upsell.card.achievements.ratingDesc')" />
      </UpsellCardAchievement>

      <UpsellCardAchievement
        :title="t('course.upsell.card.achievements.awardTitle')"
        class="min-w-[300px]"
      >
        {{t('course.upsell.card.achievements.awardDesc')}}
      </UpsellCardAchievement>
    </div>
  </div>
</template>

<style lang="scss">
@import '@mui/assets/styles/utility.scss';

.upsell-card {
  background-image: url('assets/images/illustrations/upsell/upsell-mobile@2x.png');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;

  @screen xl {
    background-image: url('assets/images/illustrations/upsell/upsell-desktop@2x.png');
    background-position: right;
  }
}
</style>